import { useUserContext } from 'providers/UserProvider';
import { userHasRole } from 'services/Authorization';
import { Roles } from 'UI/constants/roles';

export const useDailyPlanRoles = () => {
  const [currentUser] = useUserContext();

  const isDirector = userHasRole(Roles.AssistantRegionalDirector, currentUser);
  const isAccountability = userHasRole(Roles.Leadership, currentUser);
  const isOperations = userHasRole(Roles.Operations, currentUser);

  const shouldShowTeamSelector = isAccountability || isOperations;
  const shouldShowRecruiterSelector = isDirector || isAccountability || isOperations;

  return {
    isDirector,
    isAccountability,
    isOperations,
    shouldShowTeamSelector,
    shouldShowRecruiterSelector
  };
};
